<template>
  <header class="auth-header">
    <router-link :to="{ name: 'HomePage' }" class="portal-brand" aria-label="UCARI Partner Portal home">
      <img src="/images/ucari-logo-v3.png" alt="UCARI" />
      <span>Partner Portal</span>
    </router-link>
    <router-link :to="{ name: 'LoginUser' }" class="auth-header__link">Sign in</router-link>
  </header>
</template>
